import { ICoordinates } from '../../../../../types/ICoordinates';

export function calculatePointOnCircle(angle: number, center: ICoordinates, radius: number, row = 1): ICoordinates {
  const xReferToNull = Math.cos((angle / 180) * Math.PI) * (radius * row);
  const yReferToNull = Math.sin((angle / 180) * Math.PI) * (radius * row);

  return {
    x: xReferToNull + center.x,
    y: yReferToNull + center.y,
  };
}
